var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVideo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.667 10.6665H17.3337",
    stroke: "#080C11",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.66699 14.6668C2.66699 10.2671 2.66699 8.06716 4.03383 6.70034C5.40066 5.3335 7.60055 5.3335 12.0003 5.3335H13.3337C17.7334 5.3335 19.9333 5.3335 21.3002 6.70034C22.667 8.06716 22.667 10.2671 22.667 14.6668V17.3335C22.667 21.7332 22.667 23.9331 21.3002 25.3C19.9333 26.6668 17.7334 26.6668 13.3337 26.6668H12.0003C7.60055 26.6668 5.40066 26.6668 4.03383 25.3C2.66699 23.9331 2.66699 21.7332 2.66699 17.3335V14.6668Z",
    stroke: "#080C11",
    strokeWidth: 2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M22.667 11.8743L22.8349 11.7358C25.6559 9.40815 27.0665 8.24432 28.2001 8.80627C29.3337 9.36821 29.3337 11.2312 29.3337 14.9573V17.0424C29.3337 20.7685 29.3337 22.6314 28.2001 23.1934C27.0665 23.7553 25.6559 22.5916 22.8349 20.2638L22.667 20.1253",
    stroke: "#080C11",
    strokeWidth: 2,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVideo);
export default __webpack_public_path__ + "static/media/video.f9b03dcf152cbafcdb3ae25c8d4ebe9d.svg";
export { ForwardRef as ReactComponent };